import { useAppDispatch } from "@/shared/lib/redux"
import { IUser } from "@/shared/api/users"
import { openConfirmBlockModal as openConfirmBlockModalAction, UserBlockAction } from "../../model"

export const useUserBlockModal = () => {
    const dispatch = useAppDispatch()

    const openConfirmBlockModal = (user: IUser, action: UserBlockAction, onSuccess?: () => void) => {
        dispatch(openConfirmBlockModalAction({
            user,
            action,
            onSuccess
        }))
    }

    return {
        openConfirmBlockModal
    }
}
